import React, { useEffect, useState } from "react";
import axios from "../../axiosInstance";
import PropTypes from "prop-types";
import NullImage from "../../components/Images/nullImage.png";
import Loading from "../Loading/Loading";
import NewsItem from "../NewsItem/NewsItem";
import { v4 as uuidv4 } from "uuid";
import { Col, Row, Button } from "react-bootstrap";
import AdsBanner_mid from "../AdsBanner/AdsBanner_mid";
import { useParams } from 'react-router-dom';
import NavBar from "../NavBar/NavBar";
import RunningHeader from "../RunningHeader/RunningHeader";
import AdsBanner from "../AdsBanner/AdsBanner";
import Footer from "../Footer/Footer";

function CategoryNews() {
  const { category } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const district = localStorage.getItem('district');

  const articlesPerPage = 16;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  // Fetch category news with pagination
  const updateCategoryNews = async (page) => {
    if (!category) {
      setHasError(true);
      setErrorMessage("Category is invalid or not provided.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const from = (page - 1) * articlesPerPage;
      const to = from + articlesPerPage;

      const response = await axios.get(`/api/news/category/${category}`, {
        params: { district, from, to },
      });

      setArticles(response.data.news || []);
      setTotalCount(response.data.totalCount || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching category news:", error);
      setHasError(true);
      setErrorMessage(error.message || "An error occurred while fetching news.");
      setLoading(false);
    }
  };

  useEffect(() => {
    updateCategoryNews(currentPage);
  }, [category, currentPage]);

  const totalPages = Math.ceil(totalCount / articlesPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const insertAdsSeparately = () => {
    const adsEvery = 4;
    const result = [];

    articles.forEach((article, index) => {
      result.push(
        <Col sm={12} md={6} lg={4} xl={3} style={{ marginBottom: "20px" }} key={article.newsId || uuidv4()}>
          <NewsItem
            title={article.title}
            shortDescription={article.shortDescription}
            description={article.description}
            published={article.createdAt}
            channel={article.reporterName || "Unknown Channel"}
            alt="News image"
            imageUrl={article.image || NullImage}
            urlNews={`/news/${article.newsId}`}
          />
        </Col>
      );

      if ((index + 1) % adsEvery === 0) {
        result.push(
          <div key={`ad-${index}`} className="ad-banner-container-mid" style={{ marginBottom: "20px" }}>
            <AdsBanner_mid placement="Middle" page="News" />
          </div>
        );
      }
    });

    return result;
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : hasError ? (
        <div>{errorMessage}</div>
      ) : (
        <>
          <NavBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
          <RunningHeader />
          <AdsBanner placement="Header" page="News" />

          <Row className="justify-content-center">{insertAdsSeparately()}</Row>

          {/* Pagination controls */}
          <div className="pagination-controls d-flex justify-content-center align-items-center" style={{ marginTop: "20px" }}>
            <Button onClick={handlePrevPage} disabled={currentPage <= 1} className="mx-2">
              Previous
            </Button>
            <span className="mx-2" style={{ fontSize: "16px" }}>
              Page {currentPage} of {totalPages}
            </span>
            <Button onClick={handleNextPage} disabled={currentPage >= totalPages} className="mx-2">
              Next
            </Button>
          </div>

          <AdsBanner placement="Footer" page="News" />
          <Footer />
        </>
      )}
    </>
  );
}

CategoryNews.propTypes = {
  category: PropTypes.string.isRequired,
};

export default CategoryNews;
